export default {
  de: {
    singenwiedievoegel: 'Singen wie die Vögel',
    naturzentrum: 'BirdLife-Naturzentrum Klingnauer Stausee',
    ausstellung: 'Sonderausstellung 2025-2026',
    start: 'Start',
    cancel: 'Abbrechen',
    save: 'Speichern',
    next: 'Weiter'
  },
  fr: {
    singenwiedievoegel: 'Chanter comme un oiseau',
    naturzentrum: 'Centre-nature BirdLife de Klingnauer Stausee',
    ausstellung: 'Exposition temporaire 2025-2026',
    start: 'Départ',
    cancel: 'Annuler',
    save: 'Enregistrer',
    next: 'Continuer'
  }
};
